import { TemaCard } from 'src/data/models/TemaCardModel';

export const healthcareCards: TemaCard[] = [
    // 🚨 Emergencies
    new TemaCard(
        'health1',
        'Healthcare',
        'sentence',
        '¡Necesito ayuda médica urgente!',
        'I need urgent medical help!',
        'Shout this in emergencies.'
    ),
    new TemaCard(
        'health2',
        'Healthcare',
        'phrase',
        'Llame a una ambulancia, por favor.',
        'Call an ambulance, please.',
        'To alert bystanders or staff.'
    ),
    new TemaCard(
        'health3',
        'Healthcare',
        'phrase',
        '¿Dónde está el hospital más cercano?',
        'Where is the nearest hospital?',
        'When you’re in an unfamiliar place.'
    ),

    // 👩‍⚕️ Appointments & visits
    new TemaCard(
        'health4',
        'Healthcare',
        'sentence',
        'Quisiera pedir una cita con el médico.',
        'I’d like to make a doctor’s appointment.',
        'For phone or in-person scheduling.'
    ),
    new TemaCard(
        'health5',
        'Healthcare',
        'phrase',
        '¿Tienen citas disponibles hoy?',
        'Do you have appointments available today?',
        'Same-day help matters when you’re sick.'
    ),
    new TemaCard(
        'health6',
        'Healthcare',
        'sentence',
        'Tengo una cita con el doctor a las 10.',
        'I have an appointment with the doctor at 10.',
        'To confirm or check in at reception.'
    ),

    // 🤒 Symptoms & feeling unwell
    new TemaCard(
        'health7',
        'Healthcare',
        'word',
        'síntomas',
        'symptoms',
        'Describe what’s wrong.',
        [
            { spanish: 'fiebre', english: 'fever' },
            { spanish: 'tos', english: 'cough' },
            { spanish: 'dolor de cabeza', english: 'headache' },
            { spanish: 'náuseas', english: 'nausea' },
            { spanish: 'dolor de estómago', english: 'stomach ache' },
        ]
    ),
    new TemaCard(
        'health8',
        'Healthcare',
        'sentence',
        'Me duele la garganta y tengo fiebre.',
        'My throat hurts and I have a fever.',
        'Typical cold or flu complaint.'
    ),
    new TemaCard(
        'health9',
        'Healthcare',
        'sentence',
        'Tengo dolor en el pecho desde ayer.',
        'I’ve had chest pain since yesterday.',
        'Say this clearly in urgent cases.'
    ),
    new TemaCard(
        'health10',
        'Healthcare',
        'phrase',
        'Me siento muy cansado últimamente.',
        'I’ve been feeling very tired lately.',
        'Useful for general checkups.'
    ),
    new TemaCard(
        'health11',
        'Healthcare',
        'phrase',
        'Tengo una erupción en la piel.',
        'I have a skin rash.',
        'Useful for dermatology or allergies.'
    ),

    // 🏥 Talking to the doctor
    new TemaCard(
        'health12',
        'Healthcare',
        'sentence',
        '¿Es algo grave?',
        'Is it something serious?',
        'To understand your situation.'
    ),
    new TemaCard(
        'health13',
        'Healthcare',
        'phrase',
        'Estoy tomando estos medicamentos.',
        'I am taking these medications.',
        'Bring this up to avoid conflicts.'
    ),

    // 💊 At the pharmacy
    new TemaCard(
        'health15',
        'Healthcare',
        'sentence',
        '¿Dónde está la farmacia más cercana?',
        'Where is the nearest pharmacy?',
        'For emergencies or late-night needs.'
    ),
    new TemaCard(
        'health16',
        'Healthcare',
        'phrase',
        '¿Tiene algo para la tos? / el dolor de cabeza?',
        'Do you have something for a cough? / headache?',
        'Phrase for asking about common meds.'
    ),
    new TemaCard(
        'health17',
        'Healthcare',
        'phrase',
        '¿Necesito receta para esto?',
        'Do I need a prescription for this?',
        'Check if you can buy it over-the-counter.'
    ),
    new TemaCard(
        'health18',
        'Healthcare',
        'word',
        'medicina',
        'medicine',
        'Pharmacy vocabulary.',
        [
            { spanish: 'antibiótico', english: 'antibiotic' },
            { spanish: 'analgésico', english: 'painkiller' },
            { spanish: 'crema antibiótica', english: 'antibiotic cream' },
            { spanish: 'pastillas', english: 'pills' },
            { spanish: 'jarabe para la tos', english: 'cough syrup' },
        ]
    ),

    // 🧾 Cost & insurance
    new TemaCard(
        'health19',
        'Healthcare',
        'sentence',
        '¿Aceptan este seguro médico?',
        'Do you accept this health insurance?',
        'Ask before treatment.'
    ),
    new TemaCard(
        'health20',
        'Healthcare',
        'phrase',
        '¿Cuánto cuesta la consulta?',
        'How much is the consultation?',
        'Essential at private clinics.'
    ),
    new TemaCard(
        'health21',
        'Healthcare',
        'sentence',
        '¿Cuánto debo pagar por la receta?',
        'How much do I have to pay for the prescription?',
        'Pharmacy follow-up question.'
    ),

    // 🩻 Tests & follow-up
    new TemaCard(
        'health22',
        'Healthcare',
        'sentence',
        'Necesito hacerme un análisis de sangre.',
        'I need to get a blood test.',
        'Useful for labs and doctors.'
    ),
    new TemaCard(
        'health23',
        'Healthcare',
        'phrase',
        '¿Cuándo tendré los resultados?',
        'When will I get the results?',
        'Ask after any test.'
    ),
];
